import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import API from "../../../../app/api";

export const useCancelOrder = (orderNo, items = [], navigate) => {
    const [reason, setReason] = useState("");
    const [reasonList, setReasonList] = useState([]);
    const [comments, setComments] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchReasons();

        if (!items?.length) {
            navigate("/accounts/orders", { replace: true });
        }
    }, [navigate]);

    const fetchReasons = async () => {
        try {
            const { data } = await API.get("/reasons/cancellation");

            if (data?.status === 200) {
                setReasonList(data?.data || []);
            }
        } catch (error) {
            console.error(error);
            setReasonList([]);
        }
    };

    const submitCancel = async () => {
        if (!reason) {
            toast.error("Please select cancellation reason");
            return;
        }

        if (!comments.trim()) {
            toast.error("Comments are required");
            return;
        }

        if (comments.trim().length < 5) {
            toast.error("Comments should be at least 5 characters");
            return;
        }

        const itemIds = items
            .map(item => item.item_id || item.id || item.order_item_id)
            .filter(Boolean);

        if (!itemIds.length) {
            toast.error("No item found for cancellation");
            return;
        }

        setLoading(true);

        try {
            const payload = {
                item_ids: itemIds,
                reason_id: Number(reason),
                remarks: comments.trim(),
            };

            console.log("Cancel Payload:", payload);

            const { data } = await API.put(
                `/account/orders/${orderNo}/cancel`,
                payload
            );

            if (data?.success || data?.status === 200) {
                toast.success(
                    data?.message || "Order cancelled successfully"
                );

                navigate(`/accounts/orders/${orderNo}`, {
                    replace: true,
                    state: { cancelled: true },
                });
            } else {
                toast.error(data?.message || "Cancel failed");
            }
        } catch (error) {
            console.error(error?.response?.data);

            toast.error(
                error?.response?.data?.message ||
                error?.response?.data?.errors?.[0] ||
                "Cancel failed"
            );
        } finally {
            setLoading(false);
        }
    };

    return {
        reason,
        setReason,
        reasonList,
        comments,
        setComments,
        loading,
        submitCancel,
    };
};